module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/removed-items/removed-retailers/removed-retailers.component.less
// module id = ./src/app/components/popups/my-stuff/removed-items/removed-retailers/removed-retailers.component.less
// module chunks = main